<template>
    <div class="vue-rental-option" :class="{'active': active}" @click="handleClick">
        <div class="option-body">
            <button class="form-type-checkbox flex-grow-1" :aria-pressed="active ? 'true' : 'false'">
                <span :class="{ checked : active }" class="checkbox"></span>
                <span class="description">
                    <span class="font-weight-bold d-inline">
                        {{ getOptionTitle }}
                        <button @click.stop="handleModal" class="information-button">
                            {{ translations.moreInformation }}
                        </button>
                    </span>

                    <span class="subtitle d-block" v-if="option.subtitle">
                        {{ option.subtitle }}
                    </span>
                </span>
            </button>

            <div class="price">
                <span class="price-amount" v-html="generatePriceMarkup(option.price)"></span>
                <span class="periodic" v-if="option.pricePer == 'per_dag' && option.price > 0">per dag</span>
                <span class="periodic" v-if="option.pricePer == 'eenmalig' && option.price > 0">eenmalig</span>
                <span class="periodic" v-if="option.pricePer == 'per_week' && option.price > 0">per week</span>
            </div>
        </div>

        <div class="option-footer" v-if="isPopularChoice">
            <em style="font-style: normal;">{{ option.popularChoice }}</em>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import CurrencyFormatter from '../../mixins/CurrencyFormatter';
import translations from "../../mixins/translations";
import InputFormatter from "../../mixins/InputFormatter";
import ModalWrapper from "./ModalWrapper";

export default {
    name: "RentalOption",

    mixins: [CurrencyFormatter, translations, InputFormatter],

    props: ['option'],

    data() {
        return {
            isBusiness: null,
            active: false,
            tooltipActive: false,
        }
    },

    computed: {
        ...mapGetters([
            'getActiveRentalOptions',
            'getActiveRentalOptionIds',
        ]),

        isInitialActive() {

            return (lodash.isEqual(this.option.tid, 12) && !this.isBusiness)
                || (lodash.isEqual(this.option.tid, 51) && !this.isBusiness)
                || (lodash.isEqual(this.option.tid, 94) && this.isBusiness)
                || (lodash.isEqual(this.option.tid, 96) && this.isBusiness)
                || lodash.includes(this.getActiveRentalOptions, this.option);
        },

        isPopularChoice() {
            return !lodash.isEmpty(this.option.popularChoice);
        },

        getOptionTitle() {
            if (lodash.isEmpty(this.option.receiptTitle)) {
                return this.option.title;
            }

            return this.option.receiptTitle;
        }
    },

    created() {
        this.isBusiness = this.$route.meta.isBusiness ?? false;
        this.resetActiveRentalOptions(this.isBusiness);
        this.checkInitialActive();
    },

    methods: {
        ...mapActions([
            'setActiveRentalOption',
            'resetActiveRentalOptions',
            'removeActiveRentalOption'
        ]),

        generatePriceMarkup(price) {
            if (!(price > 0)) {
                return 'Gratis'
            }

            let vatExcluded = this.$options.filters.vatExcluder(price);
            let formattedPrice = this.$options.filters.currencyFormatter(vatExcluded)

            return this.checkDecimals(formattedPrice)
        },

        checkInitialActive() {
            if (!this.isInitialActive) {
                return;
            }

            this.active = true;

            if (lodash.includes(this.getActiveRentalOptions, this.option.tid)) {
                return;
            }

            this.setActiveRentalOption(this.option);
        },

        handleClick() {
            this.active = !this.active;

            if (this.active) {
                this.setActiveRentalOption(this.option);
                return;
            }

            this.removeActiveRentalOption(this.option);
        },

        handleTooltip() {
            this.tooltipActive = !this.tooltipActive;
        },

        handleModal() {
            this.$modal.show(ModalWrapper, {
                props: {
                    description: this.option.description,
                },
                label: `${this.translations.moreInformation} ${lodash.lowerCase(this.option.title)}`,
                transition: 'fade',
            });
        }
    },

    watch: {
        getActiveRentalOptionIds() {
            if (lodash.includes(this.getActiveRentalOptionIds, this.option.tid)) {
                this.checkInitialActive();
                return;
            }

            this.active = false;
        }
    }
}
</script>
